var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"loading-view"},[_c('div',{staticClass:"loading"},_vm._l((6),function(i){return _c('span',{key:i})}),0),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.content))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }